export default __webpack_public_path__ + "static/12.08-067eda71d6811b735e4ed1fc9b8dcf31.png";